import { CartLine, QueryResultSettings } from '@msdyn365-commerce/retail-proxy';
import {
    getPaginatedOrderTemplateLinesAction,
    GetPaginatedOrderTemplateLinesInput
} from '../actions/get-paginated-order-template-lines.action';
import { addCartLinesAsync, updateCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';

export async function mergeTemplateLinesToCart(
    productListId: string,
    actionContext: any,
    cartId: string,
    cartVersion: number | undefined,
    existingLines: CartLine[],
    isMultipleCatalog: boolean | undefined,
    telemetry: any,
    chunkCount = 1000
): Promise<number> {
    let addedCount = 0;
    const queryResultSettings: QueryResultSettings = {
        Paging: { Top: chunkCount, Skip: 0 }
    };
    const input = new GetPaginatedOrderTemplateLinesInput(productListId, queryResultSettings);
    let page = await getPaginatedOrderTemplateLinesAction(input, actionContext);

    while (page.lines.length > 0) {
        const qtyByItemId = page.lines.reduce((acc, line) => {
            const id = line.fullProduct?.ProductDetails.ItemId!;
            acc[id] = (acc[id] || 0) + (line.productListLine.Quantity || 1);
            return acc;
        }, {} as Record<string, number>);

        const toUpdate: CartLine[] = [];
        const toAdd: CartLine[] = [];

        for (const [itemId, qty] of Object.entries(qtyByItemId)) {
            const existing = existingLines.find(l => l.ItemId === itemId);
            if (existing) {
                toUpdate.push({ LineId: existing.LineId, Quantity: existing.Quantity! + qty });
            } else {
                const repr = page.lines.find(l => l.fullProduct?.ProductDetails.ItemId === itemId)!;
                toAdd.push({
                    ItemId: itemId,
                    ProductId: repr.productListLine.ProductId,
                    Quantity: qty,
                    TrackingId: '',
                    UnitOfMeasureSymbol: repr.productListLine.UnitOfMeasure,
                    ...(isMultipleCatalog && { catalogId: repr.productListLine.CatalogId })
                });
            }
        }

        if (toUpdate.length) {
            await updateCartLinesAsync({ callerContext: actionContext }, cartId, toUpdate, cartVersion).catch(err => {
                telemetry.trace(err.data?.ValidationResults);
                throw err;
            });
            addedCount += toUpdate.length;
        }
        if (toAdd.length) {
            await addCartLinesAsync({ callerContext: actionContext }, cartId, toAdd, cartVersion).catch(err => {
                telemetry.trace(err.data?.ValidationResults);
                throw err;
            });
            addedCount += toAdd.length;
        }

        if (input.queryResultSettings.Paging) {
            input.queryResultSettings.Paging.Skip! += chunkCount;
        }
        page = await getPaginatedOrderTemplateLinesAction(input, actionContext);
    }

    return addedCount;
}
